<template>
    <OpenableMenu>
        <template v-slot:label>
            Diensten tellen vanaf
        </template>
        <template v-slot:content>
            <List>
                <ListItem @click.stop>
                    <CustomDateSelect
                        @update:modelValue="setDate"
                        :modelValue="lastShowDeploymentCounterFrom.date ?? undefined"
                        :min="minDate"
                        :max="maxDate"
                    />
                </ListItem>
                <ListItem @click.stop>
                    <CqTextInput
                        label="Aantal dagen geleden"
                        @update:modelValue="setDays(Number($event))"
                        :modelValue="lastShowDeploymentCounterFrom.days ?? undefined"
                        :min="0"
                        :max="maxDaysInPast"
                        type="number"
                        noMargin
                    />
                </ListItem>
            </List>
        </template>
    </OpenableMenu>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {CqTextInput} from '@cquential/ui';
    import OpenableMenu from '@/components/Branding/OpenableMenu.vue';
    import List from '@/components/Branding/List.vue';
    import ListItem from '@/components/Branding/ListItem.vue';
    import CustomDateSelect from '@/components/Branding/CustomDateSelect.vue';
    import Dates from '@cquential/date-utils';
    import {DeploymentCounterStart} from '@/components/FilterBar/types';
    import {RosterViewSettings} from '@/types';

    @Component({
        components: {
            CqTextInput,
            OpenableMenu,
            List,
            ListItem,
            CustomDateSelect,
        },
        emits: ['update:showDeploymentCounterFrom'],
    })
    export default class DeploymentCounterOptionsMenu extends Vue {
        @Prop({required: true}) public showDeploymentCounterFrom!: DeploymentCounterStart;
        @Prop({required: true}) public rosterViewSettings!: RosterViewSettings;

        public lastShowDeploymentCounterFrom: DeploymentCounterStart = {date: null, days: 0};
        public maxDaysInPast: number = 365;

        public mounted(): void {
            this.lastShowDeploymentCounterFrom = this.showDeploymentCounterFrom;
            if (this.lastShowDeploymentCounterFrom.days ?? 0 > this.maxDaysInPast) {
                this.lastShowDeploymentCounterFrom.days = this.maxDaysInPast;
            }
        }

        public setDate(date: Date | undefined): void {
            this.lastShowDeploymentCounterFrom = date ? {date: date, days: null} : {date: null, days: 0};
            this.$emit('update:showDeploymentCounterFrom', this.lastShowDeploymentCounterFrom);
        }

        public setDays(days: number): void {
            if (Number.isNaN(days)) {
                days = 0;
            } else if (days > this.maxDaysInPast) {
                days = this.maxDaysInPast;
            }
            this.lastShowDeploymentCounterFrom = {date: null, days: days};
            this.$emit('update:showDeploymentCounterFrom', this.lastShowDeploymentCounterFrom);
        }

        public get minDate(): Date {
            return Dates.Utils.addDays(this.rosterViewSettings!.startDate, -this.maxDaysInPast);
        }

        public get maxDate(): Date {
            return Dates.Utils.addDays(this.rosterViewSettings!.startDate, this.rosterViewSettings!.visibleDays);
        }
    }
</script>
